<div class="container-fluid">
    <div class="row">
        <div class="col">
            <div class="card">
                <div class="card-header filter">
                    <span class="filterspan">Select sites for create a bulk</span>
                </div>
                <div class="card-body bulk-mobile" style="display: flex; justify-content: space-between;">
                    <div class="leftelements">
                        <div class="form-group">
                            <select id="type"  class="form-select" [(ngModel)]="selectedCommand">
                                <option value="">Select Command</option>
                                <option *ngFor="let list of commandList"  [value]="list.name">{{list.name}}</option>

                            </select>
                        </div>
                        <div class="form-group">
                            <div class="btn-group w-100" ngbDropdown style="position: relative;">
                                <div class="input-group">
                                <input
                                    ngbDropdownToggle
                                    type="text"
                                    class="form-control w-100"
                                    [(ngModel)]="searchTerm"
                                    placeholder="Search site..."
                                    (input)="onInputChange($event)"
                                    (click)="$event.stopPropagation()"
                                />
                                <i class="fa fa-angle-down"></i>
                                </div>

                                <ul ngbDropdownMenu class="dropdown-menu w-100">
                                <div class="scroll" style="overflow-y: auto; max-height: 250px;">
                                    <li *ngIf="!internalOptions.length"
                                        class="dropdownItems text-muted px-2 py-1">
                                    No sites available
                                    </li>

                                    <li *ngFor="let site of filteredItems"
                                        ngbDropdownItem
                                        style="cursor: pointer;"
                                        (click)="selectOption(site)">
                                    {{ site.site_name }}
                                    </li>
                                </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="rightelements-header">
                        <button class="cloud-download">
                            <img src="assets/DashboardIcon/cloud_download_icon.svg" alt="Download">
                                 Download Excel 
                        </button>
                        <button class="cloud-upload">
                            <img src="assets/DashboardIcon/cloud_upload_icon.svg" alt="Upload">
                            Upload Excel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="commandConfig[selectedCommand]">
        <div class="col">
            
            <div class="card">
            <div class="card-header filter">
                <span class="filterspan">
                {{ commandConfig[selectedCommand].title }}
                </span>
            </div>
            
            <div class="card-body d-flex" style="margin-bottom: 65px;">
                <div class="row w-100">
                    <div class="form-group {{f.class}}"
                        *ngFor="let f of commandConfig[selectedCommand].fields">
    
                        <label>{{ f.label }}</label>
    
                    <!-- TEXT -->
                        <div *ngIf="f.type === 'text' || f.type === 'password'">                
                            <input
                            [type]="f.type"
                            class=" form-control w-100"
                            [(ngModel)]="formValues[f.model]"
                            >
                        </div>
    
    
                    <!-- SELECT DROPDOWN -->
                        <div  *ngIf="f.type === 'select'">     
                            <select
                            class="form-select w-100"
                            [(ngModel)]="formValues[f.model]"
                            >
                            <option value="">Select</option>
                            <option 
                                *ngFor="let opt of (isArray(f.source) ? f.source : this[f.source])"
                                [value]="opt.id || opt._id"
                            >
                                {{ opt.name }}
                            </option>
                            </select>
                        </div>
                    <!-- YES / NO -->
                        <div *ngIf="f.type === 'selectYesNo'">
                            <select
                            class=" form-select w-100"
                            [(ngModel)]="formValues[f.model]"
                            >
                            <option value="">Yes/No</option>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                            </select>
                        </div>
                        
    
                    </div>
                </div>

            </div>

            <div class="card-body" style="background:#F5F5F5;">
                <button class="btn btn-primary"
                        (click)="submitForm()">
                Submit
                </button>
            </div>

            </div>
        </div>
    </div>

</div>